import { OperationVariables } from "@apollo/client";
import { Close } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import EditIcon from "assets/icons/EditIcon";
// import OpenEyeIcon from "assets/icons/OpenEyeIcon";
import { RefetchFunction } from "@apollo/client/react/hooks/useSuspenseQuery";
import { useDeleteQuestionMutation } from "@generated/graphql";
import ROUTES from "constants/routes";
import { ConfirmModalContext } from "context/confirmModalContext";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { parseApolloError } from "helpers/errorsParser";
import { QuestionItemType } from "pages/Skill/view/types";
import qs from "qs";
import { FC, useContext, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import QuestionImgButton from "./QuestionImgModal";

interface ActionButtonsProps {
  question: QuestionItemType;
  refetch?: RefetchFunction<unknown, OperationVariables> | (() => void);
  navigateToQuestionSearch?: string;
  disabled?: boolean;
}

const ActionButtons: FC<ActionButtonsProps> = ({ question, refetch, navigateToQuestionSearch, disabled = false }) => {
  const isConfirm = question.confirmation;
  const { handleOpen } = useContext(ConfirmModalContext);
  const { addToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);

  const [openImgModal, setOpenImgModal] = useState<boolean>();

  const [deleteQuestion, { loading: deleteLoading }] = useDeleteQuestionMutation();

  const handleDelete = () => {
    handleOpen({
      title: isConfirm ? "Вы уверены, что хотите отклонить вопрос?" : "Вы уверены, что хотите удалить вопрос?",
      actionButtonText: isConfirm ? "Отклонить" : "Удалить",
      loading: deleteLoading,
      handleClick: async () =>
        deleteQuestion({
          variables: {
            questionId: question.id,
          },
        })
          .then(() => {
            if (refetch) refetch();
            addToast({ type: ToastTypeEnum.SUCCESS });
          })
          .catch((e) => {
            parseApolloError(e, { addToast });
          }),
    });
  };

  const navigateToQuestion = () => {
    setSearchParams(qs.stringify({ ...params, questionId: question.id }), { replace: true });
    // TODO: как-будто костыль, но нужно для сохранения состояния прокрутки.
    // Возможно в последствии сохраненять состояние прокрутки не по click, а на scroll
    setTimeout(() => {
      navigate({
        pathname: `/${ROUTES.QUESTION}/view/${question.id}`,
        search: navigateToQuestionSearch,
      });
    });
  };

  return (
    <Stack
      spacing={0.5}
      sx={{
        top: 16,
        right: -8,
        position: "absolute",
      }}>
      {!question.confirmation && (
        <IconButton
          onClick={handleDelete}
          disabled={disabled}>
          <Close sx={{ color: "text.disabled", width: 20, height: 20 }} />
        </IconButton>
      )}
      <IconButton
        onClick={navigateToQuestion}
        disabled={disabled}>
        <EditIcon sx={{ color: "text.disabled", width: 20, height: 20 }} />
      </IconButton>
      {/* <IconButton onClick={() => setOpenImgModal(true)}>
        <OpenEyeIcon sx={{ color: "text.disabled", width: 24, height: 24 }} />
      </IconButton> */}
      {openImgModal && (
        <QuestionImgButton
          open={openImgModal}
          onClose={() => setOpenImgModal(false)}
          questionId={question.id}
        />
      )}
    </Stack>
  );
};

export default ActionButtons;
